<template>
    <div>
        <page-header title="Incident And Request" breadcrumb="Dashboard > Booking & Shipments > Incident And Request"
            :back="{ name: 'IncidentAndRequest' }" />
        <div class="card">
            <div class="flex justify-between">
                <div class="flex gap-4">
                    <qrcode />
                    <div class="flex flex-col">
                        <p>
                            <span class="font-bold">Truck breakdown</span> by
                            <span class="font-bold">James Obinna</span>
                        </p>
                        <p>created 10 mins ago</p>
                        <p>Status: <span class="text-green">In progress</span></p>
                        <p>Shipping Ref:MX000218</p>
                    </div>
                </div>
                <div class="flex flex-col p-3" style="background: #f9fafc">
                    <p class="text_heads">Company Contact</p>
                    <p class="inline_info">
                        <span class="inline-block w-40 opacity-50">Contact Name :</span>
                        <span>Abraham Sykes</span>
                    </p>
                    <p class="inline_info">
                        <span class="inline-block w-40 opacity-50">Office Address :</span>
                        <span>Plot 686, Tao Str, S.H.E, Lagos</span>
                    </p>
                    <p class="inline_info">
                        <span class="inline-block w-40 opacity-50">Contact No. :</span>
                        <span>071023456789</span>
                    </p>
                    <p class="inline_info">
                        <span class="inline-block w-40 opacity-50">Whatsapp :</span>
                        <span>0701023456789</span>
                    </p>
                    <p class="inline_info">
                        <span class="inline-block w-40 opacity-50">Contact Email :</span>
                        <span>asykes.eki@org</span>
                    </p>
                </div>
            </div>

            <hr class="mt-3" />
            <h4 class="mt-3">New Dispatch Information</h4>
            <b class="color_header">Vehicle Info</b>

            <div class="flex flex-wrap">
                <div class="w-full sm:w-6/12 xl:w-4/12">
                    <div class="w-full sm:w-11/12">
                        <label for="name" class="label">Fleet Name</label>
                        <input type="text" class="input_contain" placeholder="--Enter--" />
                    </div>
                </div>
                <div class="w-full sm:w-6/12 xl:w-4/12">
                    <div class="w-full sm:w-11/12">
                        <label for="name" class="label">Driver</label>
                        <input type="text" class="input_contain" placeholder="--Enter--" />
                    </div>
                </div>
                <div class="w-full sm:w-6/12 xl:w-4/12">
                    <div class="w-full sm:w-11/12">
                        <label for="name" class="label">Contact Number</label>
                        <vue-tel-input class="py-0"></vue-tel-input>
                    </div>
                </div>
                <div class="w-full sm:w-6/12 xl:w-4/12">
                    <div class="w-full sm:w-11/12">
                        <label for="name" class="label">Shipping/Dispatch Ref</label>
                        <input type="text" class="input_contain" placeholder="--Enter--" />
                    </div>
                </div>
                <div class="w-full sm:w-6/12 xl:w-4/12">
                   <div class="w-full sm:w-11/12">
                    <label class="label">Fleet Type</label>
                    <el-select filterable placeholder="Select">
                        <el-option v-for="fleet in fleetTypes" :key="fleet" :label="fleet" :value="fleet">
                        </el-option>
                    </el-select>
                   </div>
                </div>

                <div class="w-full sm:w-6/12 xl:w-4/12">
                   <div class="w-full sm:w-11/12">
                    <label for="name" class="label">Fleet ID</label>
                    <input type="text" class="input_contain" placeholder="--Enter--" />
                   </div>
                </div>
            </div>

            <hr class="mt-3" />
            <b class="color_header">Origin and Destination</b>

            <div class="flex flex-wrap">
                <div class="w-full sm:w-6/12 xl:w-4/12">
                    <div class="w-full sm:w-11/12">
                        <label class="label">Pickup Location</label>
                    <el-select filterable placeholder="Select">
                        <el-option v-for="fleet in fleetTypes" :key="fleet" :label="fleet" :value="fleet">
                        </el-option>
                    </el-select>
                    </div>
                </div>

                <div class="w-full sm:w-6/12 xl:w-4/12">
                   <div class="w-full sm:w-11/12">
                    <label for="name" class="label">Delivery Location</label>
                    <auto-complete :customStyle="customStyle" :locationDetails="viewLocationDetails"
                        placeholder="Enter Address" :value="fullAddress" />
                   </div>
                </div>
            </div>

            <div class="mt-12 flex justify-between">
                <button>Cancel</button>
                <button class="update_btn">Update</button>
            </div>
        </div>

    </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
    components: {
        PageHeader,
    },
    computed: {
        customStyle() {
            return {
                width: '100%',
                padding: '8px 10px',
                borderRadius: '5px',
                border: '1px solid grey'
            }
        },
    },
    data() {
        return {
            showImageSlides: false,
            fleetTypes: [
                "Clothings/Shoes",
                "Computer Accessories",
                "Electronics",
                "Food",
                "Health Products",
                "Jewelries/Accessories",
                "Phones",
                "Others",
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.update_btn {
    @apply px-5 py-2 bg-primary-yellow rounded
}

.input_contain {
    display: block;
    background: #fafafd;
    border: 0.5px solid #c5d1e6;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
    height: 2.65rem;
    padding: 0 0.5rem;
    margin-bottom: 1rem;
}

.color_header {
    @apply font-semibold text-primary-yellow text-base my-3
}

.text_heads {
    @apply text-base opacity-50 border-gray-400 border-0 mb-2;
    border-bottom-width: 2px;
}

.inline_info {
    @apply my-1;
}

.tab-item {
    cursor: pointer;
    // margin-right: 1rem;
    color: #5e646d;
    padding: 0.25rem 1.5rem;
    font-size: 0.9rem;

    &.active {
        background: #ffffff;
        box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
        border-radius: 5px;
        color: #fcc210;
        font-weight: bold;
    }
}
</style>